import React, { Component, Suspense, lazy } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {GET_ROLE_ID_BY_TYPE, hasAccessPermission, IS_EMP_APP } from "../config/constant";
import secureStorage from "../config/encrypt";
import AuthGuard from "./authGuard";

const AccessDenied = lazy(() => import("../view/notfound/AccessDenied"));
const LeadList = lazy(() => import("../view/lead-list/LeadList"));
const FinancierPayment = lazy(() => import("../view/fiancier/FinancierPayment"));
const Header = lazy(() => import("../view/common/Header"));
const Login = lazy(() => import("../view/user/Login"));
const LoginOtp = lazy(() => import("../view/user/LoginOtp"));
const LeadDetail = lazy(() => import("../view/lead-detail/LeadDetail"));
const AdditionalRevenue = lazy(() => import("../view/payment/AdditionalRevenue"));
const OutbountReportTab = lazy(() => import("../view/finance-report/OutbountReportTab"));
const PaymentReport = lazy(() => import("../view/Reports/payment-report/PaymentReport"));
const LoanIdReport = lazy(() => import("../view/Reports/LoanIdReport"));
const RevenueReport = lazy(() => import("../view/Reports/payment-report/RevenueReport"));
const UserRoleManagement = lazy(() => import("../view/user/UserRoleManagement"));
// check for Authorized access
const PageNotFound = lazy(() => import("../view/notfound/PageNotFound"));
const inboudPaymentUpload = lazy(() => import("../view/finance-report/inboudPaymentUpload"));
const LostLeadTab = lazy(() => import("../view/lost-lead/LostLeadTab"));
const InboundReportTab = lazy(() => import("../view/finance-report/InboundReportTab"));
const OtherTransactions = lazy(() => import("../view/other-transactions/OtherTransactions"));
const DealerWalletTab = lazy(() => import("../view/dealer-wallet/DealerWalletTab"));
const ReconcilationTab = lazy(() => import("../view/reconcilation-new/Reconcilation"));

// Dealer Wallet
const DealerTransactionHistory = lazy(() => import("../view/dealer-wallet/DealerTransactionHistory"));
const ReconViewEditTable = lazy(() => import("../view/reconcilation-new/ReconViewEditTable"));
const PendingPaymentConfirmation = lazy(() => import("../view/Reports/pending-payment/PendingPaymentConfirmation"));

// sales-task
const ManageTask = lazy(() => import("../view/sales-management/ManageTask"));
const SalesTaskTable = lazy(() => import("../view/sales-management/SalesTaskTable"));
const MonitoringTask = lazy(() => import("../view/sales-management/monitoring/MonitoringTask"));

// Monthly Payout
const MonthlyPayout = lazy(() => import("../view/monthly-payout/MonthlyPayout"));


// Testing 
const PaymentReportNew = lazy(() => import("../view/Reports/payment-loan-revenue-report/PaymentReport"));
const LoanIdReportNew = lazy(() => import("../view/Reports/payment-loan-revenue-report/LoanIdReport"));
const RevenueReportNew = lazy(() => import("../view/Reports/payment-loan-revenue-report/RevenueReport"));

const ReconReport = lazy(() => import("../view/recon-report/ReconReport"));
const DynamicBoosterReport = lazy(()=> import('../view/dynamic-booster-statement-report/dynamicBoosterTab'))
// Edited Leads
const EditedLeadTab = lazy(() => import("../view/edited-lead/EditedLeadTab"));
//Incentive Bulk payment 
const IncentivePayoutTab = lazy(()=>import('../view/User-Incentive-Payment/IncentivePayout/IncentivePayoutTab'));
const Deduction = lazy(()=>import('../view/User-Incentive-Payment/Deduction-Summary/DeductionTab'));
const UploadSummary =lazy(()=>import('../view/User-Incentive-Payment/Upload-Summary/UploadSummaryTab'));
const ReuploadSummary =lazy(()=>import('../view/User-Incentive-Payment/Reupload-Summary/ReuploadSummaryTab'))
const  ArrearSummary = lazy(()=>import("../view/User-Incentive-Payment/arrear-summary /Arrear-SummaryTab"));

//CBI Data Report
const CBIDataReport =lazy(()=>import('../view/Reports/CBI Data Report/CBIDataReprotTab') )
const UcfPendingStatement = lazy(() => import("../view/ucf-pending-statement/UcfPendingStatement"));

class CustomRouter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ht: 500,
            loggedIn: false,
        };
    }

    static getDerivedStateFromProps = (nextProps, state) => {
        const updatedProps = {};
        if (nextProps.loggedIn !== state.loggedIn) {
            updatedProps["loggedIn"] = nextProps.loggedIn;
        }
        return updatedProps;
    };

    componentDidMount = async () => {
        this.setState({ ht: window.innerHeight - 107 });
        window.addEventListener(
            "resize",
            () => {
                this.setState({ ht: window.innerHeight - 107 });
            },
            false,
        );
    };

    render() {
        var loginResponse = secureStorage.getItem("authUserInfo");
        const roleIds = loginResponse && loginResponse.user_data ? loginResponse.user_data.role_id : [];
        return (
            <Router>
                <Suspense fallback={<div className="loader is-active">Loading...</div>}>
                    {loginResponse && ( <AuthGuard> <Header /></AuthGuard>)}
                    <Routes>
                        <Route exact path="/" element={<Login />} />
                        <Route exact path="/login" element={<Login />} />
                        <Route element={<AuthGuard />}>
                        <Route exact path="/logout" element={<LoginOtp />} />
                        <Route exact path="/dashboard" element={hasAccessPermission("lead-list") ? <LeadList /> :  <AccessDenied/>} />
                        <Route exact path="/lead-list" element={hasAccessPermission("lead-list") ? <LeadList />:  <AccessDenied/>} />
                        <Route path="/lead-detail/:lead_source/:lead_id" element={hasAccessPermission("lead-detail") ? <LeadDetail /> :  <AccessDenied/>} />
                        <Route
                            path="/inbound-report/:tab/:subtab/:business_entity"
                            element={hasAccessPermission("finance-report") ? <InboundReportTab/> :  <AccessDenied/>}
                        />
                        <Route
                            path="/outbound-report/:tab/:subtab/:business_entity"
                            element={hasAccessPermission("finance-report") ? <OutbountReportTab /> :  <AccessDenied/>}
                        />
                        {/* <Route path="/dealer-wallet" element={DealerWalletTab} /> */}
                        <Route path="/wallet/:wallet_type/" element={<DealerWalletTab/>} />

                        <Route path="/loan-id/:page/:query" element={hasAccessPermission("payment-report") ? <LoanIdReport/> :  <AccessDenied/>} />

                        {/* <Route path="/loan-id/:page" element={(hasAccessPermission('payment-report')) ? LoanIdReport :  <AccessDenied/>} /> */}
                        <Route path="/revenue-report/:query" element={hasAccessPermission("payment-report") ? <RevenueReport/> :  <AccessDenied/>} />
                        <Route exact path="/payment-report" element={hasAccessPermission("payment-report") ? <PaymentReport /> :  <AccessDenied/>} />
                        <Route exact path="/payment-update" element={hasAccessPermission("payment-update") ? <AdditionalRevenue /> :  <AccessDenied/>} />
                        {/* From Elastic purpose */}
                        <Route exact path="/payment-report-new" element={hasAccessPermission("payment-report") ? <PaymentReportNew /> :  <AccessDenied/>} />
                        <Route path="/loan-id-new/:page/:query" element={hasAccessPermission("payment-report") ? <LoanIdReportNew /> :  <AccessDenied/>} />
                        <Route path="/revenue-report-new/:query" element={hasAccessPermission("payment-report") ? <RevenueReportNew /> :  <AccessDenied/>} />

                        <Route
                            exact
                            path="/financier-payment"
                            element={hasAccessPermission("financier-payment") ? <FinancierPayment/> :  <AccessDenied/>}
                        />
                        <Route exact path="/user-role" element={hasAccessPermission("user-role") && !IS_EMP_APP ? <UserRoleManagement/> : <AccessDenied/>} />
                        <Route exact path="/payment-upload" element={<inboudPaymentUpload/>} />
                        <Route exact path="/lost-after-disbursal/:lead_source" element={<LostLeadTab/>} />
                        <Route exact path="/edit-after-disbursal/:lead_source" element={<EditedLeadTab/>} />
                        <Route exact path="/reconcilation/:tab" element={<ReconcilationTab/>} />
                        <Route
                            exact
                            path="/pending-payment-confirmation"
                            element={hasAccessPermission("after-sales") ? <PendingPaymentConfirmation/> :  <AccessDenied/>}
                        />
                        <Route
                            exact
                            path="/reconcilation/:statementId/:viewPage"
                            element={hasAccessPermission("reconcillation") ? <ReconViewEditTable/> :  <AccessDenied/>}
                        />
                        <Route
                            exact
                            path="/other-transactions"
                            element={hasAccessPermission("other-transactions") ? <OtherTransactions/> :  <AccessDenied/>}
                        />

                        <Route path="/transaction-history/:dealer_id/:dealer_name/:wallet_source/:wallet_entity_type" element={<DealerTransactionHistory/>} />
                        <Route path="/monitoring-task" element={<MonitoringTask/>} />
                        <Route path="/manage-task" element={<ManageTask/>} />
                        <Route path="/sales-task-table" element={<SalesTaskTable/>} />
                        <Route path="/monthly-payout/:tabName" element={<MonthlyPayout/>} />
                        <Route
                            exact
                            path="/recon-report"
                            element={hasAccessPermission("reconcillation") ? <ReconReport/> :  <AccessDenied/>}
                        />
                        <Route path="/dynamic-booster-statement-report" element={hasAccessPermission('dynamic-booster-report') ? <DynamicBoosterReport/> :  <AccessDenied/>} />
                        {/* <Route path="/dealer-wallet/transaction-history/:query" element={(hasAccessPermission('dealer-wallet')) ? DealerTransactionHistory : DealerTransactionHistory} /> */}
                        
                        <Route  exact path="/incentive-payout" element={(roleIds?.includes(GET_ROLE_ID_BY_TYPE('sales_incentive_maker')) || roleIds?.includes(GET_ROLE_ID_BY_TYPE('sales_incentive_approver'))) ? <IncentivePayoutTab/> : <AccessDenied/>}/>
                        <Route  exact path="/deduction-summary" element={(roleIds?.includes(GET_ROLE_ID_BY_TYPE('sales_incentive_maker')) || roleIds?.includes(GET_ROLE_ID_BY_TYPE('sales_incentive_approver'))) ? <Deduction/> :<AccessDenied/>}/>
                        <Route  exact path="/upload-summary/:id" element={(roleIds?.includes(GET_ROLE_ID_BY_TYPE('sales_incentive_maker')) || roleIds?.includes(GET_ROLE_ID_BY_TYPE('sales_incentive_approver'))) ? <UploadSummary/> : <AccessDenied/>}/>
                        <Route path='/cbi-data-report' element={<CBIDataReport/>}/>
                        <Route  exact path="/reupload-summary/:id/:source?" element={(roleIds?.includes(GET_ROLE_ID_BY_TYPE('sales_incentive_maker')) || roleIds?.includes(GET_ROLE_ID_BY_TYPE('sales_incentive_approver'))) ? <ReuploadSummary/> : <AccessDenied/>}/>
                        <Route  exact path="/arrear-summary" element={(roleIds?.includes(GET_ROLE_ID_BY_TYPE('sales_incentive_maker')) || roleIds?.includes(GET_ROLE_ID_BY_TYPE('sales_incentive_approver'))) ? <ArrearSummary/> :<AccessDenied/>}/>
                        <Route path ="/ucf-pending-statement" element={<UcfPendingStatement/>} />
                        
                        <Route path="*" element={<PageNotFound/>} />
                        </Route>
                    </Routes>
                </Suspense>
            </Router>
        );
    }
}

const mapStateToProps = ({ user }) => {
    return {
        loggedIn: user.loggedIn,
    };
};
export default connect(mapStateToProps, null)(CustomRouter);
//export default Routes;
